export class P2Manager {
    constructor() {
        this._cachePos = new Laya.Vector3();
    }
    static get instance() {
        return this._instance;
    }
    static CreateInstance() {
        this._instance = new P2Manager();
    }
    get world() {
        return this._world;
    }
    InitWorld() {
        this._world = new p2.World();
        this._world.doProfiling = false;
        this._world.gravity = [0, 0];
        this._world.applyGravity = false;
        this._world.useFrictionGravityOnZeroGravity = false;
        this._world.useWorldGravityAsFrictionGravity = false;
        // this._world.applyDamping = false;
        this._world.applySpringForces = false;
        this._world.on("beginContact", this.BeginContact);
        this._world.on("endContact", this.EndContact);
    }
    Step(dt) {
        this._world.step(dt);
    }
    CreateCircleBody(radius, pos, mass = 1, isXZ = true) {
        let body = new p2.Body({
            mass: mass,
            position: [pos.x, isXZ ? pos.z : pos.y]
        });
        let circleShape = new p2.Circle({ radius: radius });
        body.addShape(circleShape);
        body.inertia = 0;
        body.allowSleep = true;
        body.damping = 0;
        return body;
    }
    CreateBoxBody(size, pos, yaw, mass = 1, isXZ = true) {
        let body = new p2.Body({
            mass: mass,
            position: [pos.x, isXZ ? pos.z : pos.y]
        });
        let shape = new p2.Box({ width: size.x, height: isXZ ? size.z : size.y });
        body.addShape(shape);
        body.inertia = 0;
        body.allowSleep = false;
        body.damping = 0;
        return body;
    }
    CreateStaticCircle(radius, pos, isXZ = true) {
        let body = new p2.Body({
            position: [pos.x, isXZ ? pos.z : pos.y]
        });
        let circleShape = new p2.Circle({ radius: radius });
        body.addShape(circleShape);
        body.type = p2.Body.STATIC;
        return body;
    }
    CreateStaticBox(size, pos, yaw, isXZ = true) {
        let body = new p2.Body({
            position: [pos.x, isXZ ? pos.z : pos.y]
        });
        let shape = new p2.Box({ width: size.x, height: isXZ ? size.z : size.y });
        body.addShape(shape);
        body.angle = yaw;
        return body;
    }
    CreateHieghtField(pos, heights, elementWidth, isXZ = true) {
        let body = new p2.Body({
            position: [pos.x, isXZ ? pos.z : pos.y]
        });
        let shape = new p2.Heightfield({
            heights,
            elementWidth
        });
        body.addShape(shape);
        return body;
    }
    CreateBody(obj, layer, mask, type) {
        let colliderCmp = obj.getComponent(Laya.PhysicsCollider);
        let scale = obj.transform.getWorldLossyScale();
        let pos = obj.transform.position;
        let body;
        if (colliderCmp == null || colliderCmp.colliderShape instanceof Laya.BoxColliderShape) {
            body = this.CreateStaticBox(scale, pos, obj.transform.rotationEuler.y / 180 * Math.PI);
            body.shapes[0].collisionGroup = layer;
            body.shapes[0].collisionMask = mask;
            body.type = type;
            // return body;
        }
        else if (colliderCmp.colliderShape instanceof Laya.SphereColliderShape) {
            let oldCmp = colliderCmp.colliderShape;
            body = this.CreateCircleBody(scale.x * oldCmp.radius, pos, 1);
            body["cacheRadius"] = oldCmp.radius;
            body.shapes[0].collisionGroup = layer;
            body.shapes[0].collisionMask = mask;
            body.type = type;
        }
        else {
            console.error("未识别的碰撞盒类型", colliderCmp);
        }
        if (colliderCmp != null) {
            colliderCmp.destroy();
        }
        return body;
    }
    AddBody(body) {
        this._world.addBody(body);
    }
    RemoveBody(body) {
        this._world.removeBody(body);
    }
    SyncTransFromRigXY(trans, rig) {
        let pos = rig.position;
        this._cachePos.setValue(pos[0], pos[1], trans.position.z);
        trans.position = this._cachePos;
    }
    SyncTransFromRigXZ(trans, rig) {
        let pos = rig.position;
        this._cachePos.setValue(pos[0], trans.position.y, pos[1]);
        trans.position = this._cachePos;
    }
    SyncTransToRigXZ(trans, rig) {
        rig.position[0] = trans.position.x;
        rig.position[1] = trans.position.z;
    }
    SyncTransFromRigAngle(trans, rig) {
        let old = trans.rotationEuler;
        old.z = rig.angle / Math.PI * 180;
        trans.rotationEuler = old;
    }
    SyncTransToRigAngle(trans, rig) {
        rig.angle = trans.rotationEuler.y / 180 * Math.PI;
    }
    BeginContact(evt) {
        let bodyA = evt.bodyA;
        let bodyB = evt.bodyB;
        if (!bodyA.collisionResponse || !bodyB.collisionResponse)
            return;
        let targetA = bodyA["use"];
        let targetB = bodyB["use"];
        targetB && (targetA === null || targetA === void 0 ? void 0 : targetA.BeginContact(targetB));
        targetA && (targetB === null || targetB === void 0 ? void 0 : targetB.BeginContact(targetA));
    }
    EndContact(evt) {
        // let bodyA = evt.bodyA;
        // let bodyB = evt.bodyB;
        // let targetA: any = bodyA.use;
        // let targetB: any = bodyB.use;
        // targetB && targetA?.EndContact(targetB);
        // targetA && targetB?.EndContact(targetA);
    }
}
